module.exports = __webpack_public_path__ + "img/help5.a81cb1ae.png";